export default __webpack_public_path__ + "static/media/description-24px.72a4f990.svg";